// src/router/index.js
import {createRouter, createWebHistory} from 'vue-router'
import Cookies from "js-cookie";
import {useAuth} from "../composables/useAuth.js";
import Dashboard from "../pages/dashboard.vue";
import Login from "../pages/login.vue";
import Register from "../pages/register.vue";
import BvDetail from "../pages/bvDetail.vue";
import Management from "../pages/Management.vue";

const routes = [
    {
        path: '/',
        name: 'home',
        components: {
            default: Dashboard, // Default view
            dynamic: Dashboard, // Named view for dynamic content
        },
    },
    {
        path: '/',
        name: 'login',
        components: {
            default: Login, // Default view
            dynamic: Login, // Named view for dynamic content
        },
    },
    {
        path: '/',
        name: 'register',
        components: {
            default: Register, // Default view
            dynamic: Register, // Named view for dynamic content
        },
    },
    {
        path: '/',
        name: 'bvDetail',
        components: {
            default: BvDetail, // Default view
            dynamic: BvDetail, // Named view for dynamic content
        },
    },
    {
        path: '/',
        name: 'management',
        components: {
            default: Management, // Default view
            dynamic: Management, // Named view for dynamic content
        },
    },
];
const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    if (to.name !== 'login' && to.name !== 'register') {
        let {getToken} = useAuth();
        // Ensure access token is available
        getToken().then(() => {
            next()
        }).catch(() => {
            next({
                name: 'login' // Redirect to login if token is not available
            })
        });
    } else {// Proceed to the route
        next()
    }
})
// Function to replace the dynamic view's component
export function replaceDynamicComponent(newComponent) {
    router.addRoute({
        path: '/',
        components: {
            default: Dashboard,
            dynamic: newComponent,
        },
    });
}
export default router